

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
//import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
      <App />
  </React.StrictMode>
);

declare global {
  interface Window {
    clearAssistantSession: () => void;
     relaySocket?: WebSocket;
  }
}
// ✅ Add global session-clearing method
if (typeof window !== 'undefined') {
  window.clearAssistantSession = function () {
    const assistantKeys = [
      'assistantId',
      'runId',
      'threadId',
      'sessionData',
      'activeBot',
      'activeUser',
      'transcript',
      'vectorStoreId',
      'localHistory',
    ];
    assistantKeys.forEach((key) => localStorage.removeItem(key));
    sessionStorage.clear();

    if (window.relaySocket && window.relaySocket.readyState === WebSocket.OPEN) {
      window.relaySocket.close(1000, '[Assistant] Relay session ended');
      console.log('[Assistant] Relay WebSocket closed.');
    }
    console.log('[Assistant] Session and WebSocket cleared.');
  };
}

(window as any).__CONFIG = {
  PAGE_TIMEOUT: 60,// 900 Timeout 15 minutes in seconds - 120 for 2 minutes
  MAX_CONNECTION_ATTEMPTS: 3, // Heartbeat Ping Keep-Alive session counter in minutes
  HEARTBEAT_PING: 55000 // MAGIC NUMBER IS ** 55000 ** millis: 120000 = 2 mins - !MPORTANT DO NOT REMOVE! Critical to keep the web socket alive.
};

const shell = document.getElementById('shadow-shell')
if (shell) shell.remove()

shell?.classList.add('fade-out')
setTimeout(() => shell?.remove(), 300)
